import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";
import CompareBar from "@/components/CompareBar";
import { CompareProvider } from "@/lib/compare";
import { FavouritesProvider } from "@/lib/favourites";
import Home from "@/pages/Home";
import Properties from "@/pages/Properties";
import PropertyDetail from "@/pages/PropertyDetail";
import Services from "@/pages/Services";
import NRI from "@/pages/NRI";
import Portal from "@/pages/Portal";
import Contact from "@/pages/Contact";
import About from "@/pages/About";
import Favourites from "@/pages/Favourites";
import Auth from "@/pages/Auth";
import Admin from "@/pages/Admin";
import { AuthProvider } from "@/lib/auth";
import useLenis from "@/lib/useLenis";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, left: 0, behavior: "auto" }); }, [pathname]);
  return null;
}

function Shell() {
  useLenis();
  const [currency, setCurrency] = useState("INR");
  return (
    <>
      <ScrollToTop />
      <Nav currency={currency} setCurrency={setCurrency} />
      <main className="relative">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/properties" element={<Properties currency={currency} />} />
          <Route path="/properties/:id" element={<PropertyDetail currency={currency} />} />
          <Route path="/services" element={<Services />} />
          <Route path="/nri" element={<NRI />} />
          <Route path="/portal" element={<Portal />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route path="/favourites" element={<Favourites currency={currency} />} />
          <Route path="/login" element={<Auth mode="login" />} />
          <Route path="/register" element={<Auth mode="register" />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </main>
      <Footer />
      <ChatWidget />
      <CompareBar currency={currency} />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#EDE6D3",
            color: "#0A2342",
            border: "1px solid #D4AF37",
            borderRadius: "0px",
            fontFamily: "Montserrat, sans-serif",
            fontSize: "13px",
            letterSpacing: "0.5px",
          },
        }}
      />
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <FavouritesProvider>
            <CompareProvider>
              <Shell />
            </CompareProvider>
          </FavouritesProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
